import { Location } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, HostListener, OnDestroy, ViewChild } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { NgbModal, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { PhotoConstant } from "src/app/shared/constants/photo.constant";
import { BreadcrumbService } from "src/app/shared/services/breadcrumb.service";
import { EventService } from "src/app/shared/services/event.service";
import { PreviewHelperService } from "src/app/shared/services/preview.service";
import { TravelKitService } from "src/app/shared/services/travel-kit.service";
import { UploadObsService } from "src/app/shared/services/upload-obs.service";
import AppShareHelper from "src/app/shared/utils/helper";
import { toUrlFriendlySlug } from "src/app/shared/utils/url-slug.util";
import Swal from "sweetalert2";
import { PreviewTempDataService } from "../../services/preview-temp-data.service";
export interface WallpaperModel {
  id?: number;
  name: string;
  url: string;
  digitalMemoryLogId: number;
  updatedAt?: string;
}

export interface CourseModel {
  name: string;
  description: string;
  banner?: string;
  courseChapters?: any[];
  id?: number;
  digitalMemoryLogId: number;
  fileType?: boolean;
  link: string;
  priceAmount?: number;
  price?: number;
  currency?: string;
  collapsed?: boolean;
  bannerUploadKey?: string;
}
@Component({
  selector: "app-travel-kit-modify",
  styleUrls: ["./travel-kit-modify.scss"],
  templateUrl: "./travel-kit-modify.html",
})
export class TravelKitModifyComponent implements OnDestroy {
  autoCheck(field: string) {
    if (!this.model[field]) {
      this.model[field] = true;
    }
    if (this.dataInitialized) {
      this.hasUnsavedChanges = true;
    }
  }

  onFormInteraction() {
    if (this.dataInitialized) {
      this.hasUnsavedChanges = true;
    }
  }

  /**
   * Handle delete section event from child components
   */
  onModelChange(updatedModel: any) {
    // Merge model một cách an toàn
    // Bảo vệ inspirationalVideo: chỉ cập nhật khi có URL hợp lệ, giữ nguyên khi null/undefined/empty
    if (updatedModel && typeof updatedModel === "object") {
      // Lưu giá trị hiện tại trước khi merge
      const currentInspirationalVideo = this.model.inspirationalVideo;
      const currentInspirationalVideoThumbnail = this.model.inspirationalVideoThumbnail;

      // Merge tất cả các field trước
      this.model = { ...this.model, ...updatedModel };

      // Xử lý inspirationalVideo: chỉ cập nhật khi có URL hợp lệ
      if (updatedModel.hasOwnProperty("inspirationalVideo")) {
        const newValue = updatedModel.inspirationalVideo;
        // Chỉ cập nhật nếu có URL hợp lệ (string không rỗng)
        if (newValue && typeof newValue === "string" && newValue.trim() !== "") {
          // URL hợp lệ, cập nhật
          this.model.inspirationalVideo = newValue;
        } else if (newValue === null) {
          // User xóa video (set null), cho phép
          this.model.inspirationalVideo = null;
        } else {
          // undefined hoặc empty string, giữ nguyên giá trị hiện tại
          if (currentInspirationalVideo) {
            this.model.inspirationalVideo = currentInspirationalVideo;
          }
        }
      } else {
        // Không có field trong update, giữ nguyên
        if (currentInspirationalVideo) {
          this.model.inspirationalVideo = currentInspirationalVideo;
        }
      }

      // Xử lý thumbnail tương tự
      if (updatedModel.hasOwnProperty("inspirationalVideoThumbnail")) {
        const newThumbnail = updatedModel.inspirationalVideoThumbnail;
        if (newThumbnail && typeof newThumbnail === "string" && newThumbnail.trim() !== "") {
          this.model.inspirationalVideoThumbnail = newThumbnail;
        } else if (newThumbnail === null) {
          this.model.inspirationalVideoThumbnail = null;
        } else {
          if (currentInspirationalVideoThumbnail) {
            this.model.inspirationalVideoThumbnail = currentInspirationalVideoThumbnail;
          }
        }
      } else {
        if (currentInspirationalVideoThumbnail) {
          this.model.inspirationalVideoThumbnail = currentInspirationalVideoThumbnail;
        }
      }
    } else {
      this.model = { ...this.model, ...updatedModel };
    }

    this.submitted = false;
    this.formValid = true;
    if (this.dataInitialized) {
      this.hasUnsavedChanges = true;
    }
  }

  /**
   * Handle delete section event from child components
   */
  onDeleteSection(sectionId: number) {
    if (sectionId) {
      this.deleteSection.push(sectionId);
      if (this.dataInitialized) this.hasUnsavedChanges = true;
    }
  }

  /**
   * Handle delete sub-section event from child components
   */
  onDeleteSubSection(subSectionId: number) {
    if (subSectionId) {
      this.deleteSubSection.push(subSectionId);
      if (this.dataInitialized) this.hasUnsavedChanges = true;
    }
  }

  /**
   * Handle delete media event from child components
   */
  onDeleteMedia(mediaId: number) {
    const normalizedMediaId = Number(mediaId);
    if (Number.isFinite(normalizedMediaId) && normalizedMediaId > 0) {
      this.deleteMedia.push(normalizedMediaId);
      if (this.dataInitialized) this.hasUnsavedChanges = true;
    }
  }

  onCourseListChange(courses: any) {
    this.courseList = courses;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onRecommendationsChange(recommendations: any) {
    this.recommendations = recommendations;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onWallpapersChange(wallpapers: any) {
    this.wallpapers = wallpapers;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onDeleteSectionChange(sections: any) {
    this.deleteSection = sections;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onDeleteSubSectionChange(subSections: any) {
    this.deleteSubSection = subSections;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onDeleteMediaChange(media: any) {
    this.deleteMedia = media;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }

  onDeleteWallpapersChange(wallpapers: any) {
    this.deleteWallpapers = wallpapers;
    if (this.dataInitialized) this.hasUnsavedChanges = true;
  }
  @ViewChild("tabset") tabset: NgbTabset;
  @ViewChild("benefitsTab") benefitsTab: any;
  @ViewChild("coursesTab") coursesTab: any;
  @ViewChild("wallpaperTab") wallpaperTab: any;
  @ViewChild("animalTab") animalTab: any;
  @ViewChild("videosTab") videosTab: any;
  @ViewChild("photosTab") photosTab: any;
  @ViewChild("mediaTab") mediaTab: any;
  defaultErrorPhoto = "./assets/images/default-error-photo.png";
  name: any;
  color = "#278ce2";
  model: any = {};
  loaded = false;
  videoFile: File;

  wallpapers: WallpaperModel[] = [];
  coverEvent: any;
  removeBannerEvent: any;

  // Course data for tab persistence
  courseList: CourseModel[] = [];
  allCoursesExpanded: boolean = false;
  courseChanges: boolean[] = [];
  originalCourses: CourseModel[] = [];

  // Wallpaper data for tab persistence
  wallpaperFiles: any[] = [];
  deleteWallpapers: any[] = [];
  wallpaperChanges: boolean[] = [];
  originalWallpapers: any[] = [];

  // Benefits & Offers data for tab persistence
  recommendations: any[] = [];
  allRecommendationsExpanded: boolean = false;
  recommendationChanges: boolean[] = [];
  originalRecommendations: any[] = [];
  allMediaSectionsExpanded: boolean = false;

  uploadingFile = false;

  readonly tabIds = [
    "brand-materials",
    "photos",
    "videos",
    "files",
    "media",
    "courses",
    "wallpapers",
    "animal-pois",
    "benefits-offers",
  ];

  currentTabIndex = 0;

  get totalTabs(): number {
    return this.tabIds.length;
  }
  fonts = [
    "Arial",
    "Atlas Grotesk",
    "Atlas Typewriter",
    "Austin",
    "Courier",
    "Courier New",
    "DejaVu Sans",
    "DejaVu Serif",
    "Georgia",
    "Helvetica",
    "Hurtigruten Display",
    "Lucida Console",
    "Lyon Text",
    "Times New Roman",
    "Verdana",
  ];
  formValid = true;
  submitted = false;
  digitalLogId: string;
  deleteMedia = [];
  deleteSection = [];
  deleteSubSection = [];
  shipId: string;
  shipName: string;
  travelKitName: string;
  mode: string = null;

  uploadProgress: { [key: string]: number } = {};
  uploadStates: { [key: string]: boolean } = {};

  objectUrlsToCleanup = new Set<string>();
  videoReady = false;

  hasUnsavedChanges = false;
  private dataInitialized = false;
  private navigatingToPreview = false;

  private routerSubscription: any;
  private hasRestoredFromPreview = false;
  private skipNextCanDeactivatePrompt = false;
  private allowNextBackNavigation = false;
  private readonly browserBackHandler = () => {
    this.handleBrowserBackNavigation();
  };
  constructor(
    protected http: HttpClient,
    public toastr: ToastrService,
    protected _modalService: NgbModal,
    protected travelKitService: TravelKitService,
    protected route: ActivatedRoute,
    private router: Router,
    protected eventService: EventService,
    protected uploadService: UploadObsService,
    private breadcrumbService: BreadcrumbService,
    private location: Location,
    private previewHelper: PreviewHelperService,
    private previewTempDataService: PreviewTempDataService
  ) {}

  @HostListener("window:beforeunload", ["$event"])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

  @HostListener("input", ["$event"])
  @HostListener("change", ["$event"])
  onHostFormInteraction(event: Event): void {
    if (!this.dataInitialized) {
      return;
    }

    const target = event && (event.target as HTMLElement | null);
    if (!target) {
      return;
    }

    // Ignore non-editing UI changes (tab navigation, view toggle, etc.).
    const isEditableControl =
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement ||
      target.isContentEditable;

    if (!isEditableControl) {
      return;
    }

    const isDisabledControl =
      (target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement) &&
      target.disabled;
    if (isDisabledControl) {
      return;
    }

    this.hasUnsavedChanges = true;
  }

  canDeactivate(): Promise<boolean> | boolean {
    if (this.allowNextBackNavigation) {
      this.allowNextBackNavigation = false;
      return true;
    }

    if (this.skipNextCanDeactivatePrompt) {
      this.skipNextCanDeactivatePrompt = false;
      return false;
    }

    if (this.navigatingToPreview) {
      this.navigatingToPreview = false;
      return true;
    }

    if (!this.hasUnsavedChanges) {
      return true;
    }

    return Swal.fire({
      title: "Unsaved Changes",
      html: "You have unpublished changes. If you leave this page, your changes will be lost.<br><br><strong>Do you want to leave without publishing?</strong>",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ffa300 !important",
      cancelButtonColor: "#969696",
      confirmButtonText: "Leave without publishing",
      cancelButtonText: "Stay on this page",
    }).then(result => {
      return !!result.value;
    });
  }

  ngOnInit() {
    this.mode = this.route.snapshot.paramMap.get("mode");
    this.digitalLogId = this.route.snapshot.paramMap.get("groupId");

    this.shipId = this.route.snapshot.paramMap.get("shipId");
    this.shipName = this.route.snapshot.paramMap.get("shipName");

    if (!this.shipId) {
      const oldId = this.route.snapshot.paramMap.get("id");
      if (oldId) {
        this.shipId = oldId;
        this.shipName = this.route.snapshot.queryParamMap.get("name");
      }
    }

    this.initializeUploadTracking();

    // Subscribe router events để detect browser back button
    this.setupRouterSubscription();
    this.setupBrowserBackHandling();

    // Check xem có quay lại từ preview không (từ query param hoặc sessionStorage)
    this.checkAndRestoreFromPreview();
  }

  /**
   * Setup router subscription để detect khi user dùng browser back button
   */
  private setupRouterSubscription() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Khi navigate về create/edit page, check xem có flag từ preview không
        if (event.url.includes("create-digital-memory-log-") || event.url.includes("edit-digital-memory-log-")) {
          // Delay một chút để đảm bảo component đã init
          setTimeout(() => {
            this.checkAndRestoreFromPreview();
          }, 100);
        }
      });
  }
  private setupBrowserBackHandling() {
    if (typeof window === "undefined") {
      return;
    }
    window.addEventListener("popstate", this.browserBackHandler);
  }

  private handleBrowserBackNavigation() {
    if (typeof window === "undefined") {
      return;
    }

    if (this.allowNextBackNavigation || !this.hasUnsavedChanges) {
      return;
    }

    // Cancel this popstate navigation path and keep user on current page.
    this.skipNextCanDeactivatePrompt = true;
    window.history.pushState(window.history.state, "", this.router.url);

    Swal.fire({
      title: "Unsaved Changes",
      html: "You have unpublished changes. If you leave this page, your changes will be lost.<br><br><strong>Do you want to leave without publishing?</strong>",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ffa300 !important",
      cancelButtonColor: "#969696",
      confirmButtonText: "Leave without publishing",
      cancelButtonText: "Stay on this page",
    }).then(result => {
      if (result.value) {
        this.hasUnsavedChanges = false;
        this.allowNextBackNavigation = true;
        this.location.back();
      }
    });
  }
  /**
   * Check xem có quay lại từ preview không và restore data nếu có
   */
  private checkAndRestoreFromPreview() {
    // Tránh restore nhiều lần
    if (this.hasRestoredFromPreview) {
      return;
    }

    const fromPreviewQuery = this.route.snapshot.queryParamMap.get("fromPreview") === "true";
    const previewFlagKey = `preview_navigation_${this.digitalLogId}`;
    const fromPreviewStorage = this.digitalLogId ? sessionStorage.getItem(previewFlagKey) === "true" : false;

    // Nếu có flag từ query param hoặc storage, restore data
    if (fromPreviewQuery || fromPreviewStorage) {
      // Clear flag sau khi đã check
      if (fromPreviewStorage && this.digitalLogId) {
        sessionStorage.removeItem(previewFlagKey);
      }

      if (this.digitalLogId) {
        this.hasRestoredFromPreview = true;
        this.restoreDataFromStorage();
      }
    } else {
      // Nếu không, load từ API như bình thường
      this.loadDataFromApi();
    }
  }

  /**
   * Load data từ API
   */
  private loadDataFromApi() {
    if (this.digitalLogId) {
      this.travelKitService
        .getTravelKitByGroupId(this.digitalLogId)
        .toPromise()
        .then((travelKitData: any) => {
          this.model = travelKitData.Data;
          this.sortSectionsByIndex();
          this.loaded = true;
          this.initializeDefaultValues();
          this.breadcrumbService.setEditDigitalMemoryLogBreadcrumbs(
            this.digitalLogId,
            this.model.name || "Digital Memory Log"
          );
          setTimeout(() => {
            this.dataInitialized = true;
          }, 500);
        });
    } else {
      this.breadcrumbService.setCreateDigitalMemoryLogBreadcrumbs();
      this.loaded = true;
      this.initializeDefaultValues();
      setTimeout(() => {
        this.dataInitialized = true;
      }, 500);
    }
  }

  onPreviewClick(file: any, type: "file" | "photo" | "video", allowDownload: boolean = false) {
    this.previewHelper.openPreview(file, type, allowDownload);
  }

  get isEditMode(): boolean {
    if (this.mode === "edit") return true;
    if (this.mode === "create") return false;

    const currentUrl = this.router.url;
    if (currentUrl.includes("edit-digital-memory-log-") || currentUrl.includes("/edit/")) {
      return true;
    }

    return this.route.snapshot.url[0] && this.route.snapshot.url[0].path === "edit";
  }

  get breadcrumbActionText(): string {
    return this.isEditMode ? "Edit Travel Guide" : "Create Travel Guide";
  }

  removeInspirationalVideo() {
    this.model.inspirationalVideo = null;
    this.model.inspirationalVideoThumbnail = null;
  }

  isValidUrl(url: string): boolean {
    if (!url) return true;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  validateForm(): boolean {
    this.formValid = true;
    // Set submitted flag khi validate (để hiển thị lỗi)
    this.submitted = true;

    // Validate từng tab theo thứ tự
    if (!this.validateBrandMaterialsTab()) {
      return false;
    }

    if (!this.validatePhotosTab()) {
      return false;
    }

    if (!this.validateVideosTab()) {
      return false;
    }

    if (!this.validateFilesTab()) {
      return false;
    }

    if (!this.validateMediaTab()) {
      return false;
    }

    if (!this.validateCoursesTab()) {
      return false;
    }

    if (!this.validateWallpapersTab()) {
      return false;
    }

    if (!this.validateAnimalPoisTab()) {
      return false;
    }

    if (!this.validateBenefitsOffersTab()) {
      return false;
    }

    return true;
  }

  private markInvalid(tabId: string = "brand-materials"): boolean {
    this.formValid = false;
    if (this.tabset && tabId) {
      this.tabset.select(tabId);
      this.currentTabIndex = this.tabIds.indexOf(tabId);
    }
    return false;
  }

  private getTabIdByDisplayKey(displayKey: string): string {
    const map = {
      displayPhotos: "photos",
      displayVideos: "videos",
      displayFiles: "files",
      displayMedias: "media",
    };
    return map[displayKey] || "brand-materials";
  }

  /**
   * Validate Brand Materials Tab
   * - name, brandColor, brandFont: luôn validate khi publish
   * - Các field khác: chỉ validate khi checkbox show = true
   */
  private validateBrandMaterialsTab(): boolean {
    // Luôn validate các field bắt buộc
    if (!this.model.name) {
      return this.markInvalid("brand-materials");
    }

    if (!this.model.brandColor) {
      return this.markInvalid("brand-materials");
    }

    if (!this.model.brandFont) {
      return this.markInvalid("brand-materials");
    }

    // Validate các field conditional (chỉ khi checkbox show = true)
    // if (this.model.displayLink && !this.model.link) {
    //   this.toastr.error("Please input travel kit link");
    //   this.formValid = false;
    //   return false;
    // }

    if (this.model.displayBanner && !this.model.banner) {
      return this.markInvalid("brand-materials");
    }

    if (this.model.displayBrandLogo && !this.model.brandLogo) {
      return this.markInvalid("brand-materials");
    }

    if (this.model.displayDescription && !this.model.description) {
      return this.markInvalid("brand-materials");
    }

    // Kiểm tra nếu đang upload thì không báo validation error
    const isUploadingInspirationalVideo =
      this.model.inspirationalVideoUploadKey &&
      (this.uploadStates[this.model.inspirationalVideoUploadKey] === true ||
        (this.uploadProgress[this.model.inspirationalVideoUploadKey] !== undefined &&
          this.uploadProgress[this.model.inspirationalVideoUploadKey] > 0 &&
          this.uploadProgress[this.model.inspirationalVideoUploadKey] < 100));

    if (this.model.displayInspirationalVideo && !this.model.inspirationalVideo && !isUploadingInspirationalVideo) {
      return this.markInvalid("brand-materials");
    }

    return true;
  }

  /**
   * Shared validation for media section tabs (Photos/Videos/Files)
   */
  private validateStructuredMediaTab(config: {
    displayKey: "displayPhotos" | "displayVideos" | "displayFiles";
    titleKey: "titlePhotoSections" | "titleVideoSections" | "titleFileSections";
    sectionsKey: "photoSections" | "videoSections" | "fileSections";
    mainTitleError: string;
    sectionMissingError: string;
    sectionTitleError: (sectionIndex: number) => string;
    subSectionMissingError: (sectionIndex: number) => string;
    subSectionTitleError: (sectionIndex: number, subIndex: number) => string;
    subSectionPageTitleError: (sectionIndex: number, subIndex: number) => string;
  }): boolean {
    if (!this.model[config.displayKey]) {
      return true; // Nếu không enable thì skip validation
    }

    if (!this.model[config.titleKey]) {
      return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
    }

    const sections = this.model[config.sectionsKey] || [];
    if (!sections.length) {
      return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
    }

    for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex++) {
      const section = sections[sectionIndex];
      if (!section.name) {
        return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
      }

      if (!section.subSections || section.subSections.length === 0) {
        return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
      }

      for (let subIndex = 0; subIndex < section.subSections.length; subIndex++) {
        const subsection = section.subSections[subIndex];
        if (!subsection.title) {
          return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
        }

        if (!subsection.pageTitle) {
          return this.markInvalid(this.getTabIdByDisplayKey(config.displayKey));
        }
      }
    }

    return true;
  }

  /**
   * Validate Photos Tab
   */
  private validatePhotosTab(): boolean {
    if (
      !this.validateStructuredMediaTab({
        displayKey: "displayPhotos",
        titleKey: "titlePhotoSections",
        sectionsKey: "photoSections",
        mainTitleError: "In photos section, Please input photos main title",
        sectionMissingError: "In photos section, Please add at least one photo section",
        sectionTitleError: sectionIndex => `In photos section, Please input photo section ${sectionIndex + 1} title`,
        subSectionMissingError: sectionIndex =>
          `In photos section, Please add at least one sub-section in photo section ${sectionIndex + 1}`,
        subSectionTitleError: (sectionIndex, subIndex) =>
          `In photos section, Please input sub-section ${subIndex + 1} title in photo section ${sectionIndex + 1}`,
        subSectionPageTitleError: (sectionIndex, subIndex) =>
          `In photos section, Please input page title in photo section ${sectionIndex + 1}, sub-section ${subIndex + 1}`,
      })
    ) {
      return false;
    }

    // Validate photo limits using the tab component
    if (this.photosTab && !this.photosTab.validateAndShowErrors()) {
      this.formValid = false;
      return false;
    }

    return true;
  }

  /**
   * Validate Videos Tab
   */
  private validateVideosTab(): boolean {
    if (
      !this.validateStructuredMediaTab({
        displayKey: "displayVideos",
        titleKey: "titleVideoSections",
        sectionsKey: "videoSections",
        mainTitleError: "In videos section, Please input videos main title",
        sectionMissingError: "In videos section, Please add at least one video section",
        sectionTitleError: sectionIndex => `In videos section, Please input video section ${sectionIndex + 1} title`,
        subSectionMissingError: sectionIndex =>
          `In videos section, Please add at least one sub-section in video section ${sectionIndex + 1}`,
        subSectionTitleError: (sectionIndex, subIndex) =>
          `In videos section, Please input sub-section ${subIndex + 1} title in video section ${sectionIndex + 1}`,
        subSectionPageTitleError: (sectionIndex, subIndex) =>
          `In videos section, Please input page title in video section ${sectionIndex + 1}, sub-section ${subIndex + 1}`,
      })
    ) {
      return false;
    }

    // Validate video limits using the tab component
    if (this.videosTab && !this.videosTab.validateAndShowErrors()) {
      this.formValid = false;
      return false;
    }

    return true;
  }

  /**
   * Validate Files Tab
   */
  private validateFilesTab(): boolean {
    return this.validateStructuredMediaTab({
      displayKey: "displayFiles",
      titleKey: "titleFileSections",
      sectionsKey: "fileSections",
      mainTitleError: "In files section, Please input files main title",
      sectionMissingError: "In files section, Please add at least one file section",
      sectionTitleError: sectionIndex => `In files section, Please input section ${sectionIndex + 1} title`,
      subSectionMissingError: sectionIndex =>
        `In files section, Please add at least one sub-section in section ${sectionIndex + 1}`,
      subSectionTitleError: (sectionIndex, subIndex) =>
        `In files section, Please input sub-section ${subIndex + 1} title in section ${sectionIndex + 1}`,
      subSectionPageTitleError: (sectionIndex, subIndex) =>
        `In files section, Please input page title in section ${sectionIndex + 1}, sub-section ${subIndex + 1}`,
    });
  }

  /**
   * Validate Media Tab
   */
  private validateMediaTab(): boolean {
    if (
      !this.validateStructuredMediaTab({
        displayKey: "displayMedias" as any,
        titleKey: "titleMediaSections" as any,
        sectionsKey: "mediaSections" as any,
        mainTitleError: "In media section, Please input media main title",
        sectionMissingError: "In media section, Please add at least one media section",
        sectionTitleError: sectionIndex => `In media section, Please input section ${sectionIndex + 1} title`,
        subSectionMissingError: sectionIndex =>
          `In media section, Please add at least one sub-section in section ${sectionIndex + 1}`,
        subSectionTitleError: (sectionIndex, subIndex) =>
          `In media section, Please input sub-section ${subIndex + 1} title in section ${sectionIndex + 1}`,
        subSectionPageTitleError: (sectionIndex, subIndex) =>
          `In media section, Please input page title in section ${sectionIndex + 1}, sub-section ${subIndex + 1}`,
      })
    ) {
      return false;
    }

    if (this.mediaTab && !this.mediaTab.validateAndShowErrors()) {
      this.formValid = false;
      return false;
    }

    return true;
  }

  /**
   * Validate Courses Tab
   */
  private validateCoursesTab(): boolean {
    if (this.coursesTab && !this.coursesTab.validateCourses()) {
      this.formValid = false;
      return false;
    }
    return true;
  }

  /**
   * Validate Wallpapers Tab
   */
  private validateWallpapersTab(): boolean {
    if (!this.model.displayWallpapers) {
      return true; // Nếu không enable thì skip validation
    }

    if (this.wallpaperTab && !this.wallpaperTab.validateWallpapers()) {
      this.formValid = false;
      return false;
    }

    return true;
  }

  /**
   * Validate Animal & POIs Tab
   */
  private validateAnimalPoisTab(): boolean {
    if (!this.model.displayAnimalPOI) {
      return true; // Nếu không enable thì skip validation
    }

    if (this.animalTab && !this.animalTab.validateAnimal()) {
      this.formValid = false;
      return false;
    }

    return true;
  }

  /**
   * Validate Benefits & Offers Tab
   */
  private validateBenefitsOffersTab(): boolean {
    if (this.benefitsTab && !this.benefitsTab.validateRecommendations()) {
      this.formValid = false;
      return false;
    }
    return true;
  }

  /** Preview/share slug; delegate tới toUrlFriendlySlug (shared util). */
  getUrlFriendlyName(name: string): string {
    return toUrlFriendlySlug(name);
  }

  async saveTravelKit() {
    // Kiểm tra xem có file/video/photo đang upload không - chỉ cảnh báo, không chặn
    if (this.hasActiveUploads()) {
      this.toastr.warning(
        "Warning: There are video/file/photo uploads in progress. Some data may not be saved completely."
      );
    }
    if (!this.validateForm()) return;

    const transformedModel = {
      ...this.model,
      status: true,
      shareUrl: `${window.location.origin}/preview-${this.getUrlFriendlyName(this.model.name)}-${this.model.id}`,
    };

    try {
      await this.travelKitService.saveTravelKit(this.digitalLogId, transformedModel).toPromise();
      await this.createSectionsForEnabledTabs();
      this.hasUnsavedChanges = false;
      this.toastr.success("Travel Guide published successfully");
    } catch (error) {
      this.toastr.error("Failed to update travel kit");
      console.error("Save travel kit error:", error);
    } finally {
      this.refreshTravelKitData();
    }
  }

  private isExistingId(id: any): boolean {
    return id && typeof id === "number" && id > 0;
  }

  private mapMediaPayload(media: any, type: "pdf" | "image" | "video", includeThumbnail: boolean = false) {
    const payload: any = {
      id: media.id,
      type: type,
      url: media.url,
      width: media.width || 0,
      height: media.height || 0,
      fileName: media.fileName || "",
      size: media.size || 0,
    };

    if (includeThumbnail) {
      payload.thumbnail = media.thumbnail;
    }

    return payload;
  }

  private buildSubSectionData(
    subsection: any,
    subIndex: number,
    sectionId: number,
    mediaType: "pdf" | "image" | "video",
    includeThumbnail: boolean = false
  ) {
    const isNewSub = !this.isExistingId(subsection.id);

    return {
      id: subsection.id,
      title: subsection.title,
      pageTitle: subsection.pageTitle,
      description: subsection.description,
      sectionId: sectionId,
      display: subsection.display !== undefined ? subsection.display : true,
      index: isNewSub ? subIndex : subsection.index || subIndex,
      media: (subsection.media || []).map(media => this.mapMediaPayload(media, mediaType, includeThumbnail)),
    };
  }

  /** Media tab: mixed image + video per subsection — per-item type and thumbnail for videos */
  private buildMediaSubSectionData(subsection: any, subIndex: number, sectionId: number) {
    const isNewSub = !this.isExistingId(subsection.id);
    return {
      id: subsection.id,
      title: subsection.title,
      pageTitle: subsection.pageTitle,
      description: subsection.description,
      sectionId: sectionId,
      display: subsection.display !== undefined ? subsection.display : true,
      index: isNewSub ? subIndex : subsection.index || subIndex,
      media: (subsection.media || []).map((media: any) => {
        const isVideo = String(media.type || "").toLowerCase() === "video";
        return this.mapMediaPayload(media, isVideo ? "video" : "image", isVideo);
      }),
    };
  }

  private buildSectionData(section: any, sectionIndex: number, sectionType: string) {
    const isNewSection = !this.isExistingId(section.id);

    return {
      name: section.name,
      digitalMemoryLogId: this.digitalLogId,
      type: sectionType,
      id: section.id,
      display: section.display !== undefined ? section.display : true,
      index: isNewSection ? sectionIndex : section.index || sectionIndex,
    };
  }

  private addDeletePromises(sectionPromises: Promise<any>[]) {
    if (this.deleteMedia && this.deleteMedia.length > 0) {
      this.deleteMedia.forEach(id => {
        const normalizedId = Number(id);
        if (Number.isFinite(normalizedId) && normalizedId > 0) {
          sectionPromises.push(this.travelKitService.deleteMedia(normalizedId).toPromise());
        }
      });
    }

    if (this.deleteSection && this.deleteSection.length > 0) {
      sectionPromises.push(this.travelKitService.deleteSection(this.deleteSection).toPromise());
    }

    if (this.deleteSubSection && this.deleteSubSection.length > 0) {
      const subSectionIdsToDelete = this.deleteSubSection.filter(id => id);
      if (subSectionIdsToDelete.length > 0) {
        sectionPromises.push(this.travelKitService.deleteSubSection(subSectionIdsToDelete).toPromise());
      }
    }

    if (this.deleteWallpapers && this.deleteWallpapers.length > 0) {
      this.deleteWallpapers.forEach(wallpaperId => {
        if (wallpaperId) {
          sectionPromises.push(this.travelKitService.deleteWallpaper(wallpaperId).toPromise());
        }
      });
    }
  }

  private async executeSectionAndSubSectionPromises(
    sectionPromises: Promise<any>[],
    subSectionPromises: Promise<any>[]
  ): Promise<void> {
    if (sectionPromises.length > 0) {
      await Promise.all(sectionPromises);
    }

    if (subSectionPromises.length > 0) {
      await Promise.all(subSectionPromises);
    }
  }

  private enqueueSectionSavePromises(
    section: any,
    sectionIndex: number,
    apiSectionType: string,
    mediaType: "pdf" | "image" | "video",
    includeThumbnail: boolean,
    sectionPromises: Promise<any>[]
  ): void {
    const sectionData = this.buildSectionData(section, sectionIndex, apiSectionType);

    if (this.isExistingId(section.id)) {
      sectionPromises.push(this.travelKitService.updateSection(sectionData).toPromise());
    } else {
      const newSectionData = {
        ...sectionData,
        subSections: (section.subSections || []).map((subsection, subIndex) =>
          this.buildSubSectionData(subsection, subIndex, section.id, mediaType, includeThumbnail)
        ),
      };
      sectionPromises.push(
        this.travelKitService
          .createSection(newSectionData)
          .toPromise()
          .then(createdSection => createdSection)
      );
    }
  }

  private enqueueSubSectionSavePromises(
    subsection: any,
    subIndex: number,
    section: any,
    subSectionPromises: Promise<any>[],
    options:
      | { mode: "photo"; mediaType: "image" }
      | { mode: "thumbnail-media"; mediaType: "pdf" | "video"; createMediaTypeFallback?: string }
  ): void {
    const includeThumbnail = options.mode === "thumbnail-media";
    const subSectionData = this.buildSubSectionData(
      subsection,
      subIndex,
      section.id,
      options.mediaType,
      includeThumbnail
    );

    if (!this.isExistingId(subsection.id)) {
      subSectionPromises.push(this.travelKitService.createSubSection(subSectionData).toPromise());
      return;
    }

    if (options.mode === "photo") {
      const newItems = subSectionData.media.filter(media => !media.id);
      if (newItems.length > 0) {
        newItems.forEach(media => {
          const mediaData = {
            ...media,
            subSectionId: subSectionData.id,
          };
          subSectionPromises.push(this.travelKitService.createMedia(mediaData).toPromise());
        });
      }
      subSectionPromises.push(this.travelKitService.updateSubSection(subSectionData).toPromise());
      return;
    }

    const newMedia = subSectionData.media.filter(media => !media.id || typeof media.id !== "number" || media.id <= 0);
    const existingMedia = subSectionData.media.filter(
      media => media.id && typeof media.id === "number" && media.id > 0
    );

    if (newMedia.length > 0) {
      newMedia.forEach(media => {
        if (media.url) {
          const mediaData = {
            type:
              options.createMediaTypeFallback !== undefined
                ? media.type || options.createMediaTypeFallback
                : media.type,
            url: media.url,
            width: media.width || 0,
            height: media.height || 0,
            fileName: media.fileName || "",
            size: media.size || 0,
            thumbnail: media.thumbnail,
            subSectionId: subSectionData.id,
          };
          subSectionPromises.push(this.travelKitService.createMedia(mediaData).toPromise());
        }
      });
    }

    if (existingMedia.length > 0) {
      existingMedia.forEach(media => {
        if (media.thumbnail && media.thumbnail.trim() !== "") {
          const mediaData = {
            type: media.type || "pdf",
            url: media.url || "",
            width: media.width || 0,
            height: media.height || 0,
            fileName: media.fileName || "",
            size: media.size || 0,
            thumbnail: media.thumbnail,
            subSectionId: subSectionData.id,
          };
          subSectionPromises.push(this.travelKitService.updateMedia(mediaData, media.id).toPromise());
        }
      });
    }

    const validMedia = subSectionData.media.filter(
      media => (media.id && typeof media.id === "number" && media.id > 0) || (media.url && media.url.trim() !== "")
    );

    subSectionPromises.push(
      this.travelKitService
        .updateSubSection({
          ...subSectionData,
          media: validMedia,
        })
        .toPromise()
    );
  }

  /**
   * Save Media tab subsections (mixed photos + videos): same API pattern as Photos + Videos —
   * createMedia for new items, updateMedia for existing videos when thumbnail is set, then updateSubSection.
   */
  private enqueueMediaSubSectionSavePromises(
    subsection: any,
    subIndex: number,
    section: any,
    subSectionPromises: Promise<any>[]
  ): void {
    const subSectionData = this.buildMediaSubSectionData(subsection, subIndex, section.id);

    if (!this.isExistingId(subsection.id)) {
      subSectionPromises.push(this.travelKitService.createSubSection(subSectionData).toPromise());
      return;
    }

    const newMedia = subSectionData.media.filter(media => !media.id || typeof media.id !== "number" || media.id <= 0);
    newMedia.forEach(media => {
      if (media.url) {
        const mediaData = {
          type: media.type || "image",
          url: media.url,
          width: media.width || 0,
          height: media.height || 0,
          fileName: media.fileName || "",
          size: media.size || 0,
          thumbnail: media.thumbnail,
          subSectionId: subSectionData.id,
        };
        subSectionPromises.push(this.travelKitService.createMedia(mediaData).toPromise());
      }
    });

    const existingMedia = subSectionData.media.filter(
      media => media.id && typeof media.id === "number" && media.id > 0
    );
    existingMedia.forEach(media => {
      const isVideo = String(media.type || "").toLowerCase() === "video";
      if (isVideo && media.thumbnail && media.thumbnail.trim() !== "") {
        const mediaData = {
          type: media.type || "video",
          url: media.url || "",
          width: media.width || 0,
          height: media.height || 0,
          fileName: media.fileName || "",
          size: media.size || 0,
          thumbnail: media.thumbnail,
          subSectionId: subSectionData.id,
        };
        subSectionPromises.push(this.travelKitService.updateMedia(mediaData, media.id).toPromise());
      }
    });

    const validMedia = subSectionData.media.filter(
      media => (media.id && typeof media.id === "number" && media.id > 0) || (media.url && media.url.trim() !== "")
    );

    subSectionPromises.push(
      this.travelKitService
        .updateSubSection({
          ...subSectionData,
          media: validMedia,
        })
        .toPromise()
    );
  }

  private async createSectionsForEnabledTabs() {
    // Save courses using the tab component
    if (this.coursesTab) {
      await this.coursesTab.saveCourses();
    }

    // Save recommendations using the tab component
    if (this.benefitsTab) {
      await this.benefitsTab.saveRecommendations();
    }

    // Save wallpapers using the tab component
    if (this.wallpaperTab) {
      await this.wallpaperTab.saveWallpapers();
    }

    // Save animal data using the tab component
    if (this.animalTab) {
      await this.animalTab.saveAnimal();
    }

    // Then handle other sections
    return new Promise<void>((resolve, reject) => {
      const sectionPromises = [];
      const subSectionPromises = [];
      const mediaTypes = ["photo", "file", "video"];

      // Sắp theo index để section mới luôn ở cuối. Section/subsection mới (chưa có id) gửi index = vị trí trong mảng.
      this.sortSectionsByIndex();

      if (this.model.fileSections && this.model.fileSections.length > 0) {
        this.model.fileSections.forEach((section, sectionIndex) => {
          this.enqueueSectionSavePromises(section, sectionIndex, mediaTypes[1], "pdf", true, sectionPromises);
          if (section.subSections && section.subSections.length > 0) {
            section.subSections.forEach((subsection, subIndex) => {
              this.enqueueSubSectionSavePromises(subsection, subIndex, section, subSectionPromises, {
                mode: "thumbnail-media",
                mediaType: "pdf",
                createMediaTypeFallback: "pdf",
              });
            });
          }
        });
      }

      if (this.model.photoSections && this.model.photoSections.length > 0) {
        this.model.photoSections.forEach((section, sectionIndex) => {
          this.enqueueSectionSavePromises(section, sectionIndex, mediaTypes[0], "image", false, sectionPromises);
          if (section.subSections && section.subSections.length > 0) {
            section.subSections.forEach((subsection, subIndex) => {
              this.enqueueSubSectionSavePromises(subsection, subIndex, section, subSectionPromises, {
                mode: "photo",
                mediaType: "image",
              });
            });
          }
        });
      }

      if (this.model.videoSections && this.model.videoSections.length > 0) {
        this.model.videoSections.forEach((section, sectionIndex) => {
          this.enqueueSectionSavePromises(section, sectionIndex, mediaTypes[2], "video", true, sectionPromises);
          if (section.subSections && section.subSections.length > 0) {
            section.subSections.forEach((subsection, subIndex) => {
              this.enqueueSubSectionSavePromises(subsection, subIndex, section, subSectionPromises, {
                mode: "thumbnail-media",
                mediaType: "video",
              });
            });
          }
        });
      }

      if (this.model.mediaSections && this.model.mediaSections.length > 0) {
        this.model.mediaSections.forEach((section, sectionIndex) => {
          const sectionData = this.buildSectionData(section, sectionIndex, "media");
          if (this.isExistingId(section.id)) {
            sectionPromises.push(this.travelKitService.updateSection(sectionData).toPromise());
          } else {
            const newSectionData = {
              ...sectionData,
              subSections: (section.subSections || []).map((subsection, subIndex) =>
                this.buildMediaSubSectionData(subsection, subIndex, section.id)
              ),
            };
            sectionPromises.push(this.travelKitService.createSection(newSectionData).toPromise());
          }

          if (section.subSections && section.subSections.length > 0) {
            section.subSections.forEach((subsection, subIndex) => {
              this.enqueueMediaSubSectionSavePromises(subsection, subIndex, section, subSectionPromises);
            });
          }
        });
      }
      this.addDeletePromises(sectionPromises);

      this.executeSectionAndSubSectionPromises(sectionPromises, subSectionPromises)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.error("Error processing sections/subsections:", error);
          this.toastr.error("Failed to process some sections or subsections");
          reject(error);
        });
    });
  }

  private refreshTravelKitData() {
    if (this.digitalLogId) {
      this.dataInitialized = false;
      this.travelKitService
        .getTravelKitByGroupId(this.digitalLogId)
        .toPromise()
        .then((travelKitData: any) => {
          this.model = travelKitData.Data;
          this.sortSectionsByIndex();

          this.deleteMedia = [];
          this.deleteSection = [];
          this.deleteSubSection = [];
          this.deleteWallpapers = [];

          const serverWallpapers = this.model.wallpapers || [];
          const filteredWallpapers = serverWallpapers.filter(
            wallpaper => !this.deleteWallpapers.includes(wallpaper.id)
          );

          this.wallpapers = filteredWallpapers;
          this.hasUnsavedChanges = false;
          setTimeout(() => {
            this.dataInitialized = true;
          }, 500);
        })
        .catch(error => {
          console.error("Failed to refresh travel kit data:", error);
          this.hasUnsavedChanges = false;
          setTimeout(() => {
            this.dataInitialized = true;
          }, 500);
        });
    }
  }

  onTabChange(event: any) {
    this.currentTabIndex = this.tabIds.indexOf(event.nextId);
  }

  nextTab() {
    this.navigateTab(1);
  }

  previousTab() {
    this.navigateTab(-1);
  }

  private navigateTab(step: 1 | -1) {
    const nextIndex = this.currentTabIndex + step;
    if (nextIndex < 0 || nextIndex >= this.totalTabs) {
      return;
    }

    this.currentTabIndex = nextIndex;
    if (this.tabset) {
      this.tabset.select(this.tabIds[this.currentTabIndex]);
    }
    this.topFunction();
  }

  topFunction() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private createShipUrl(): string {
    const urlFriendlyShipName = toUrlFriendlySlug(this.shipName, { emptyFallback: "ship" });
    return `ship-${urlFriendlyShipName}-${this.shipId}`;
  }

  previewTravelKit() {
    const shipUrl = this.createShipUrl();

    let previewName = "travelkit";
    if (this.model && this.model.name && String(this.model.name).trim() !== "") {
      previewName = toUrlFriendlySlug(this.model.name);
    }

    const previewUrl = `preview-${previewName}-${this.digitalLogId}`;

    this.saveTempPreviewData();

    if (this.digitalLogId) {
      const previewFlagKey = `preview_navigation_${this.digitalLogId}`;
      sessionStorage.setItem(previewFlagKey, "true");
    }

    this.navigatingToPreview = true;

    this.router.navigate(["overview", shipUrl, previewUrl], {
      queryParams: {
        type: this.isEditMode ? "edit" : "create",
      },
    });
  }

  /**
   * Lưu data hiện tại vào storage để preview có thể sử dụng
   */
  private saveTempPreviewData() {
    if (!this.digitalLogId) {
      return;
    }

    // Lấy courses từ courseList (luôn lưu, kể cả empty array)
    // Fix: deepClone có thể convert array thành object, nên cần đảm bảo luôn là array
    let coursesToSave: any[] = [];
    if (Array.isArray(this.courseList) && this.courseList.length > 0) {
      // Clone từng item để tránh reference issues
      coursesToSave = this.courseList.map(course => AppShareHelper.deepClone(course));
    }

    // Thu thập tất cả data từ các tab components
    const previewData: any = {
      ...this.model,
      // ALWAYS save courses (even if empty array) - this ensures restore works correctly
      courses: coursesToSave,
      // Đảm bảo displayCourses được lưu
      displayCourses: this.model.displayCourses !== undefined ? this.model.displayCourses : false,
      // Lấy recommendations từ recommendations (đảm bảo luôn là array)
      recommendations:
        Array.isArray(this.recommendations) && this.recommendations.length > 0
          ? this.recommendations.map(rec => AppShareHelper.deepClone(rec))
          : [],
      // Lấy wallpapers từ wallpapers (đảm bảo luôn là array)
      wallpapers:
        Array.isArray(this.wallpapers) && this.wallpapers.length > 0
          ? this.wallpapers.map(wallpaper => AppShareHelper.deepClone(wallpaper))
          : [],
    };

    // Lấy animal POI data từ animalTab hoặc từ model
    if (this.animalTab && this.animalTab.model && this.animalTab.model.animalPOI) {
      previewData.animalPOI = this.animalTab.model.animalPOI;
      previewData.animalPOIFileName = this.animalTab.model.animalPOIFileName;
    } else if (this.model.animalPOI) {
      previewData.animalPOI = this.model.animalPOI;
      previewData.animalPOIFileName = this.model.animalPOIFileName;
    }

    previewData._hasUnsavedChanges = this.hasUnsavedChanges;

    this.previewTempDataService.setTempPreviewData(this.digitalLogId, previewData);
  }

  /**
   * Restore data từ storage khi quay lại từ preview
   */
  private restoreDataFromStorage() {
    try {
      if (!this.digitalLogId) {
        // Nếu không có digitalLogId, load như create mode
        this.breadcrumbService.setCreateDigitalMemoryLogBreadcrumbs();
        this.loaded = true;
        this.initializeDefaultValues();
        return;
      }

      const tempData = this.previewTempDataService.getTempPreviewData(this.digitalLogId);

      if (tempData && typeof tempData === "object") {
        // Đảm bảo model có id
        if (!tempData.id && this.digitalLogId) {
          tempData.id = parseInt(this.digitalLogId, 10);
        }

        // Extract courses trước khi spread để tránh conflict
        const coursesToRestore = tempData.courses;

        // Restore model data - đảm bảo model là object hợp lệ
        this.model = tempData && typeof tempData === "object" ? { ...tempData } : {};

        // Đảm bảo model không null/undefined
        if (!this.model || typeof this.model !== "object") {
          this.model = {};
        }

        // Đảm bảo các mảng sections được khởi tạo
        this.model.fileSections = Array.isArray(this.model.fileSections) ? this.model.fileSections : [];
        this.model.photoSections = Array.isArray(this.model.photoSections) ? this.model.photoSections : [];
        this.model.mediaSections = Array.isArray(this.model.mediaSections) ? this.model.mediaSections : [];

        // Restore courses - sử dụng coursesToRestore đã extract
        if (coursesToRestore !== undefined) {
          try {
            // Đảm bảo coursesToRestore là array
            if (Array.isArray(coursesToRestore)) {
              if (coursesToRestore.length > 0) {
                const clonedCourses = AppShareHelper.deepClone(coursesToRestore);
                // Đảm bảo clonedCourses là array
                if (Array.isArray(clonedCourses)) {
                  this.courseList = [...clonedCourses];
                  this.courseChanges = new Array(this.courseList.length).fill(false);
                  this.originalCourses = AppShareHelper.deepClone(this.courseList);
                  this.allCoursesExpanded = true;
                  this.model.courses = [...this.courseList];
                } else {
                  console.warn("deepClone returned non-array, using original array");
                  this.courseList = [...coursesToRestore];
                  this.courseChanges = new Array(this.courseList.length).fill(false);
                  this.originalCourses = [...coursesToRestore];
                  this.allCoursesExpanded = true;
                  this.model.courses = [...this.courseList];
                }
              } else {
                // Empty array
                this.courseList = [];
                this.courseChanges = [];
                this.originalCourses = [];
                this.allCoursesExpanded = true;
                this.model.courses = [];
              }
            } else {
              console.warn("coursesToRestore is not an array:", coursesToRestore);
              this.courseList = [];
              this.courseChanges = [];
              this.originalCourses = [];
              this.allCoursesExpanded = true;
              this.model.courses = [];
            }
          } catch (error) {
            console.error("Error restoring courses:", error);
            this.courseList = [];
            this.courseChanges = [];
            this.originalCourses = [];
            this.allCoursesExpanded = true;
            this.model.courses = [];
          }
        } else if (this.model.courses && Array.isArray(this.model.courses) && this.model.courses.length > 0) {
          // Fallback: nếu coursesToRestore undefined nhưng model.courses có data (từ spread)
          this.courseList = Array.isArray(this.model.courses) ? [...this.model.courses] : [];
          this.courseChanges = new Array(this.courseList.length).fill(false);
          this.originalCourses = AppShareHelper.deepClone(this.courseList);
          this.allCoursesExpanded = true;
        } else {
          // Ensure courseList is initialized as empty array
          this.courseList = [];
          this.courseChanges = [];
          this.originalCourses = [];
          this.allCoursesExpanded = true;
          this.model.courses = [];
        }

        // Restore recommendations
        if (tempData.recommendations !== undefined) {
          try {
            let recommendationsToRestore = tempData.recommendations;

            // Fix: deepClone có thể convert array thành object, cần đảm bảo luôn là array
            if (recommendationsToRestore && !Array.isArray(recommendationsToRestore)) {
              // Convert object với numeric keys thành array
              console.warn("recommendations is not an array, converting to array...");
              const recommendationsObject = recommendationsToRestore;
              recommendationsToRestore = Object.keys(recommendationsObject)
                .filter(key => !isNaN(Number(key)))
                .sort((a, b) => Number(a) - Number(b))
                .map(key => recommendationsObject[key]);
            }

            if (Array.isArray(recommendationsToRestore) && recommendationsToRestore.length > 0) {
              // Clone từng item để tránh reference issues
              this.recommendations = recommendationsToRestore.map(rec => AppShareHelper.deepClone(rec));
              this.recommendationChanges = new Array(this.recommendations.length).fill(false);
              this.originalRecommendations = this.recommendations.map(rec => AppShareHelper.deepClone(rec));
              this.allRecommendationsExpanded = true;
            } else {
              this.recommendations = [];
              this.recommendationChanges = [];
              this.originalRecommendations = [];
              this.allRecommendationsExpanded = true;
            }
            this.model.recommendations = this.recommendations;
          } catch (error) {
            console.error("Error restoring recommendations:", error);
            this.recommendations = [];
            this.recommendationChanges = [];
            this.originalRecommendations = [];
            this.allRecommendationsExpanded = true;
            this.model.recommendations = [];
          }
        }

        // Restore wallpapers
        if (tempData.wallpapers !== undefined) {
          try {
            let wallpapersToRestore = tempData.wallpapers;

            // Fix: deepClone có thể convert array thành object, cần đảm bảo luôn là array
            if (wallpapersToRestore && !Array.isArray(wallpapersToRestore)) {
              // Convert object với numeric keys thành array
              console.warn("wallpapers is not an array, converting to array...");
              const wallpapersObject = wallpapersToRestore;
              wallpapersToRestore = Object.keys(wallpapersObject)
                .filter(key => !isNaN(Number(key)))
                .sort((a, b) => Number(a) - Number(b))
                .map(key => wallpapersObject[key]);
            }

            if (Array.isArray(wallpapersToRestore) && wallpapersToRestore.length > 0) {
              // Clone từng item để tránh reference issues
              this.wallpapers = wallpapersToRestore.map(wallpaper => AppShareHelper.deepClone(wallpaper));
              this.wallpaperFiles = this.wallpapers.map(wallpaper => ({
                file: null,
                src: wallpaper.url || "",
                title: String(wallpaper.name || ""),
                time: new Date(String(wallpaper.updatedAt || Date.now())),
                uploadKey: undefined,
                tempId: undefined,
              }));
              this.wallpaperChanges = new Array(this.wallpapers.length).fill(false);
              this.originalWallpapers = this.wallpapers.map(wallpaper => AppShareHelper.deepClone(wallpaper));
            } else {
              this.wallpapers = [];
              this.wallpaperFiles = [];
              this.wallpaperChanges = [];
              this.originalWallpapers = [];
            }
            this.model.wallpapers = this.wallpapers;
          } catch (error) {
            console.error("Error restoring wallpapers:", error);
            this.wallpapers = [];
            this.wallpaperFiles = [];
            this.wallpaperChanges = [];
            this.originalWallpapers = [];
            this.model.wallpapers = [];
          }
        }

        // Restore animal POI
        if (tempData.animalPOI !== undefined) {
          this.model.animalPOI = tempData.animalPOI;
        }
        if (tempData.animalPOIFileName !== undefined) {
          this.model.animalPOIFileName = tempData.animalPOIFileName;
        }

        // Set các giá trị mặc định chỉ cho các field không có trong tempData
        if (!this.model.brandColor) {
          this.model.brandColor = "#000000";
        }
        if (!this.model.brandFont) {
          this.model.brandFont = "Times New Roman";
        }

        // Đảm bảo delete arrays được khởi tạo
        this.deleteMedia = [];
        this.deleteSection = [];
        this.deleteSubSection = [];
        this.deleteWallpapers = [];

        // Gọi initializeDefaultValuesForRestore để đảm bảo tất cả các field được khởi tạo đúng
        this.initializeDefaultValuesForRestore();

        // Đảm bảo tất cả các field quan trọng được khởi tạo
        this.ensureModelFieldsInitialized();

        this.loaded = true;
        const savedUnsavedFlag = tempData._hasUnsavedChanges;
        setTimeout(() => {
          this.dataInitialized = true;
          if (savedUnsavedFlag) {
            this.hasUnsavedChanges = true;
          }
        }, 500);

        if (this.isEditMode) {
          this.breadcrumbService.setEditDigitalMemoryLogBreadcrumbs(
            this.digitalLogId,
            this.model.name || "Travel Guide"
          );
        } else {
          this.breadcrumbService.setCreateDigitalMemoryLogBreadcrumbs();
        }
      } else {
        // Nếu không có data trong storage hoặc data không hợp lệ, load từ API
        console.warn("No valid temp data found, loading from API");
        this.loadDataFromApi();
      }
    } catch (error) {
      console.error("Error restoring data from storage:", error);
      // Nếu có lỗi, fallback về load từ API
      this.loadDataFromApi();
    }
  }

  /**
   * Đảm bảo tất cả các field quan trọng trong model được khởi tạo
   */
  private ensureModelFieldsInitialized() {
    // Đảm bảo model là object hợp lệ
    if (!this.model || typeof this.model !== "object") {
      this.model = {};
    }

    // Đảm bảo các mảng sections được khởi tạo
    this.model.fileSections = Array.isArray(this.model.fileSections) ? this.model.fileSections : [];
    this.model.photoSections = Array.isArray(this.model.photoSections) ? this.model.photoSections : [];
    this.model.videoSections = Array.isArray(this.model.videoSections) ? this.model.videoSections : [];
    this.model.mediaSections = Array.isArray(this.model.mediaSections) ? this.model.mediaSections : [];

    // Đảm bảo các field boolean được khởi tạo
    if (this.model.displayBanner === undefined) this.model.displayBanner = false;
    if (this.model.displayBrandLogo === undefined) this.model.displayBrandLogo = false;
    if (this.model.displayDescription === undefined) this.model.displayDescription = false;
    if (this.model.displayInspirationalVideo === undefined) this.model.displayInspirationalVideo = false;
    if (this.model.displayFiles === undefined) this.model.displayFiles = false;
    if (this.model.displayPhotos === undefined) this.model.displayPhotos = false;
    if (this.model.displayVideos === undefined) this.model.displayVideos = false;
    if (this.model.displayMedias === undefined) this.model.displayMedias = false;
    if (this.model.displayCourses === undefined) this.model.displayCourses = false;
    if (this.model.displayWallpapers === undefined) this.model.displayWallpapers = false;
    if (this.model.displayAnimalPOI === undefined) this.model.displayAnimalPOI = false;
    if (this.model.displayRecommendations === undefined) this.model.displayRecommendations = false;
    if (this.model.displayLink === undefined) this.model.displayLink = false;

    // Đảm bảo các field string được khởi tạo
    if (this.model.name === undefined) this.model.name = "";
    if (this.model.description === undefined) this.model.description = "";
    if (this.model.link === undefined) this.model.link = "";
    if (this.model.banner === undefined) this.model.banner = "";
    if (this.model.brandLogo === undefined) this.model.brandLogo = "";
    if (this.model.brandColor === undefined) this.model.brandColor = "#000000";
    if (this.model.brandFont === undefined) this.model.brandFont = "Times New Roman";
    if (this.model.titleFileSections === undefined) this.model.titleFileSections = "";
    if (this.model.titlePhotoSections === undefined) this.model.titlePhotoSections = "";
    if (this.model.titleVideoSections === undefined) this.model.titleVideoSections = "";
    if (this.model.titleMediaSections === undefined) this.model.titleMediaSections = "";
  }

  /**
   * Initialize default values cho restore (không ghi đè data đã restore)
   */
  private initializeDefaultValuesForRestore() {
    // Chỉ set các giá trị mặc định cho các field chưa có
    if (!this.model.brandColor) {
      this.model.brandColor = "#000000";
    }
    if (!this.model.brandFont) {
      this.model.brandFont = "Times New Roman";
    }

    // Đảm bảo các mảng được khởi tạo
    this.model.fileSections = this.model.fileSections || [];
    this.model.photoSections = this.model.photoSections || [];
    this.model.videoSections = this.model.videoSections || [];
    this.model.mediaSections = this.model.mediaSections || [];

    // Nếu courses chưa được restore, khởi tạo từ model.courses
    if (this.courseList.length === 0 && this.model.courses && this.model.courses.length > 0) {
      this.courseList = AppShareHelper.deepClone(this.model.courses);
      this.courseChanges = new Array(this.courseList.length).fill(false);
      this.originalCourses = AppShareHelper.deepClone(this.courseList);
      this.allCoursesExpanded = true;
    }

    // Nếu recommendations chưa được restore, khởi tạo từ model.recommendations
    if (this.recommendations.length === 0 && this.model.recommendations && this.model.recommendations.length > 0) {
      this.recommendations = AppShareHelper.deepClone(this.model.recommendations);
      this.recommendationChanges = new Array(this.recommendations.length).fill(false);
      this.originalRecommendations = AppShareHelper.deepClone(this.recommendations);
      this.allRecommendationsExpanded = true;
    }

    // Nếu wallpapers chưa được restore, khởi tạo từ model.wallpapers
    if (this.wallpapers.length === 0 && this.model.wallpapers && this.model.wallpapers.length > 0) {
      this.wallpapers = AppShareHelper.deepClone(this.model.wallpapers);
      this.wallpaperFiles = this.wallpapers.map(wallpaper => ({
        file: null,
        src: wallpaper.url,
        title: String(wallpaper.name),
        time: new Date(String(wallpaper.updatedAt || Date.now())),
        uploadKey: undefined,
        tempId: undefined,
      }));
      this.wallpaperChanges = new Array(this.wallpapers.length).fill(false);
      this.originalWallpapers = AppShareHelper.deepClone(this.wallpapers);
    }
  }

  /**
   * Hiển thị popup warning khi có upload đang diễn ra và user muốn publish
   * @param title - Tiêu đề popup
   * @param mainMessage - Thông điệp chính
   * @param onConfirm - Callback khi user confirm
   * @param confirmButtonText - Text cho nút confirm
   */
  private showUploadWarningPopup(
    title: string,
    mainMessage: string,
    onConfirm: () => void,
    confirmButtonText: string = "Yes, publish it!"
  ): void {
    const hasActiveUploads = this.hasActiveUploads();
    const warningMessage = hasActiveUploads
      ? '<div style="color: #ff9800; font-weight: bold; margin-top: 10px; padding: 10px; background-color: #fff3cd; border-left: 4px solid #ff9800; border-radius: 4px; font-size: 14px;">⚠️ Warning: Publishing is not available while the upload is in progress. Please try again once it completes.</div>'
      : "";

    const swalOptions: any = {
      title: title,
      html: `${mainMessage}${warningMessage}`,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#9E1915 !important",
      cancelButtonColor: "#969696 !important",
      confirmButtonText: confirmButtonText,
      cancelButtonText: "Cancel",
      allowEnterKey: !hasActiveUploads,
      allowOutsideClick: !hasActiveUploads,
      // Ẩn hoàn toàn nút confirm khi có active uploads
      showConfirmButton: !hasActiveUploads,
    };

    Swal.fire(swalOptions).then(result => {
      // Kiểm tra lại một lần nữa trước khi confirm
      if (result.value && !this.hasActiveUploads()) {
        onConfirm();
      } else if (result.value && this.hasActiveUploads()) {
        // Nếu user vẫn click được (edge case), hiển thị warning
        this.toastr.warning(
          "Warning: There are video/file/photo uploads in progress. Publishing is disabled until uploads complete."
        );
      }
    });
  }

  publishTravelKit() {
    // Kiểm tra xem có file/video/photo đang upload không - chỉ cảnh báo, không chặn
    if (this.hasActiveUploads()) {
      this.toastr.warning(
        "Warning: There are video/file/photo uploads in progress. Please wait for uploads to complete before publishing."
      );
    }

    if (!this.validateForm()) return;

    // Sử dụng helper method để hiển thị popup warning
    this.showUploadWarningPopup("Publish Travel Guide?", "This will make your Travel Guide available to users.", () => {
      this.model.published = true;
      this.saveTravelKit();
    });
  }
  isFileSizeValid(file: File): boolean {
    if (file.type === "application/pdf") {
      return file.size <= 100 * 1024 * 1024;
    }

    return file.size <= PhotoConstant.MAX_FILE_SIZE;
  }

  isFileTypeValid(file: File): boolean {
    const fileTypes = ["image/jpeg", "image/jpg", "image/png", "image/heic", "image/heif"];
    const isHeicByExtension = /\.(heic|heif)$/i.test(file.name);
    return (
      fileTypes.includes(file.type) || (isHeicByExtension && (!file.type || file.type === "application/octet-stream"))
    );
  }

  isFileTypePdf(fileUrl: string): boolean {
    const fileExtension = fileUrl.split(".").pop().toLowerCase();
    if (fileExtension === "pdf") {
      return true;
    } else {
      return false;
    }
  }

  toggleSectionCollapse(section: any) {
    section.collapsed = !section.collapsed;
  }

  toggleSubsectionCollapse(subsection: any) {
    subsection.collapsed = !subsection.collapsed;
  }

  trackByIndex(index: number, item: any): any {
    return index;
  }

  getFileUploadText(subsection: any): string {
    const fileCount = subsection.media.length || 0;
    if (fileCount === 0) {
      return "Select File";
    } else if (fileCount === 1) {
      return `1 file selected`;
    } else {
      return `${fileCount} files selected`;
    }
  }

  getFileType(file: File): string {
    const mimeType = file.type.toLowerCase();

    if (mimeType.startsWith("image/")) {
      return "image";
    } else if (mimeType.startsWith("video/")) {
      return "video";
    } else if (mimeType === "application/pdf") {
      return "pdf";
    } else if (mimeType.includes("word") || mimeType.includes("document")) {
      return "document";
    } else if (mimeType.includes("sheet") || mimeType.includes("excel")) {
      return "spreadsheet";
    } else if (mimeType.includes("presentation") || mimeType.includes("powerpoint")) {
      return "presentation";
    } else {
      return "file";
    }
  }

  getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
      img.onerror = () => {
        resolve({ width: 0, height: 0 });
      };
      img.src = URL.createObjectURL(file);
    });
  }

  getPhotoUploadText(subsection: any): string {
    if (!subsection.media || subsection.media.length === 0) {
      return "Select Photos";
    }
    const count = subsection.media.length;
    return count === 1 ? "1 photo selected" : `${count} photos selected`;
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  getVideoCountInSection(sectionIndex: number): number {
    if (!this.model.videoSections || !this.model.videoSections[sectionIndex]) {
      return 0;
    }

    let totalVideos = 0;
    const section = this.model.videoSections[sectionIndex];

    if (section.subSections) {
      section.subSections.forEach(subsection => {
        if (subsection.media && subsection.media.length) {
          totalVideos += subsection.media.length;
        }
      });
    }

    return totalVideos;
  }

  isVideoSectionAtMaxCapacity(sectionIndex: number): boolean {
    return this.getVideoCountInSection(sectionIndex) >= 15;
  }

  getPhotoCountInSection(sectionIndex: number): number {
    if (!this.model.photoSections || !this.model.photoSections[sectionIndex]) {
      return 0;
    }

    let totalPhotos = 0;
    const section = this.model.photoSections[sectionIndex];

    if (section.subSections) {
      section.subSections.forEach(subsection => {
        if (subsection.media && subsection.media.length) {
          totalPhotos += subsection.media.length;
        }
      });
    }

    return totalPhotos;
  }

  isPhotoSectionAtMaxCapacity(sectionIndex: number): boolean {
    return this.getPhotoCountInSection(sectionIndex) >= 500;
  }

  getFileSizeInSubsection(sectionIndex: number, subIndex: number): number {
    if (
      !this.model.fileSections ||
      !this.model.fileSections[sectionIndex] ||
      !this.model.fileSections[sectionIndex].subSections ||
      !this.model.fileSections[sectionIndex].subSections[subIndex]
    ) {
      return 0;
    }

    const subsection = this.model.fileSections[sectionIndex].subSections[subIndex];
    let totalSizeBytes = 0;

    if (subsection.media) {
      subsection.media.forEach(media => {
        if (media.size) {
          totalSizeBytes += media.size;
        }
      });
    }

    return totalSizeBytes / (1024 * 1024);
  }

  isFileSubsectionAtMaxCapacity(sectionIndex: number, subIndex: number): boolean {
    return this.getFileSizeInSubsection(sectionIndex, subIndex) >= 100;
  }

  initializeDefaultValues() {
    if (!this.model.brandColor) {
      this.model.brandColor = "#000000";
    }

    if (!this.model.brandFont) {
      this.model.brandFont = "Times New Roman";
    }

    this.model.fileSections = this.model.fileSections || [];
    this.model.photoSections = this.model.photoSections || [];
    this.model.videoSections = this.model.videoSections || [];
    this.model.mediaSections = this.model.mediaSections || [];
    this.wallpapers = this.model.wallpapers || [];

    // Initialize course data
    this.courseList =
      this.model.courses && this.model.courses.length > 0
        ? this.model.courses
        : [
            {
              name: "",
              description: "",
              banner: "",
              courseChapters: [],
              digitalMemoryLogId: this.model.id || this.digitalLogId,
              link: "",
              price: null,
              currency: "",
              collapsed: false,
            },
          ];
    this.courseChanges = new Array(this.courseList.length).fill(false);
    this.originalCourses = AppShareHelper.deepClone(this.courseList);
    this.allCoursesExpanded = true;

    // Initialize wallpaper data
    this.wallpapers = this.model.wallpapers || [];
    this.deleteWallpapers = [];
    this.wallpaperFiles = this.wallpapers.map(wallpaper => ({
      file: null,
      src: wallpaper.url,
      title: String(wallpaper.name),
      time: new Date(String(wallpaper.updatedAt || Date.now())),
      uploadKey: undefined,
      tempId: undefined,
    }));
    this.wallpaperChanges = new Array(this.wallpapers.length).fill(false);
    this.originalWallpapers = AppShareHelper.deepClone(this.wallpapers);

    // Initialize recommendations data
    this.recommendations =
      this.model.recommendations && this.model.recommendations.length > 0
        ? this.model.recommendations
        : [
            {
              type: "",
              subCategory: "",
              title: "",
              description: "",
              banner: "",
              price: null,
              currency: "",
              link: "",
              digitalMemoryLogId: this.model.id || this.digitalLogId,
              collapsed: false,
            },
          ];
    this.recommendationChanges = new Array(this.recommendations.length).fill(false);
    this.originalRecommendations = AppShareHelper.deepClone(this.recommendations);
    this.allRecommendationsExpanded = true;
  }

  goBack() {
    this.confirmNavigationAway(() => {
      if (this.shipId && this.shipName) {
        const shipUrl = this.createShipUrl();
        this.router.navigate(["/overview", shipUrl]);
      } else if (this.shipId) {
        this.router.navigate(["/overview", this.shipId]);
      } else {
        this.location.back();
      }
    });
  }

  navigateToOverview() {
    this.confirmNavigationAway(() => {
      this.router.navigate(["/overview"]);
    });
  }

  private confirmNavigationAway(onConfirm: () => void) {
    if (!this.hasUnsavedChanges) {
      onConfirm();
      return;
    }

    Swal.fire({
      title: "Unsaved Changes",
      html: "You have unpublished changes. If you leave this page, your changes will be lost.<br><br><strong>Do you want to leave without publishing?</strong>",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FFA300 !important",
      cancelButtonColor: "#969696 !important",
      confirmButtonText: "Leave without publishing",
      cancelButtonText: "Stay on this page",
    }).then(result => {
      if (result.value) {
        this.hasUnsavedChanges = false;
        onConfirm();
      }
    });
  }

  initializeUploadTracking() {
    this.uploadProgress = {};
    this.uploadStates = {};
  }

  generateUploadKey(type: string, fileName: string, identifier?: string): string {
    const timestamp = Date.now();
    return identifier ? `${type}_${identifier}_${fileName}_${timestamp}` : `${type}_${fileName}_${timestamp}`;
  }

  setUploadProgress(key: string, progress: number) {
    this.uploadProgress[key] = progress;
  }

  setUploadState(key: string, isUploading: boolean) {
    this.uploadStates[key] = isUploading;
  }

  getUploadProgress(key: string): number {
    if (!key) return 0;
    return this.uploadProgress[key] || 0;
  }

  getUploadState(key: string): boolean {
    if (!key) return false;
    return this.uploadStates[key] || false;
  }

  cleanupUpload(key: string) {
    delete this.uploadProgress[key];
    delete this.uploadStates[key];
  }

  isAnyFileUploading(): boolean {
    return Object.values(this.uploadStates).some(state => state === true);
  }

  /**
   * Check if there are any active uploads (for disabling preview/publish buttons)
   */
  hasActiveUploads(): boolean {
    // Check general upload progress (0 < progress < 100)
    const hasPendingUpload = Object.values(this.uploadProgress).some(value => value > 0 && value < 100);
    if (hasPendingUpload) {
      return true;
    }

    // Check upload states
    const hasActiveUploadState = Object.values(this.uploadStates).some(isUploading => isUploading === true);
    if (hasActiveUploadState) {
      return true;
    }

    // Check upload keys in model (inspirationalVideo, banner, brandLogo, etc.)
    if (this.model) {
      // Check inspirationalVideoUploadKey
      if (this.model.inspirationalVideoUploadKey) {
        const uploadKey = this.model.inspirationalVideoUploadKey;
        const isUploading = this.uploadStates[uploadKey] === true;
        const progress = this.uploadProgress[uploadKey];
        const hasActiveProgress = progress !== undefined && progress > 0 && progress < 100;
        if (isUploading || hasActiveProgress) {
          return true;
        }
      }

      // Check bannerUploadKey
      if (this.model.bannerUploadKey) {
        const uploadKey = this.model.bannerUploadKey;
        const isUploading = this.uploadStates[uploadKey] === true;
        const progress = this.uploadProgress[uploadKey];
        const hasActiveProgress = progress !== undefined && progress > 0 && progress < 100;
        if (isUploading || hasActiveProgress) {
          return true;
        }
      }

      // Check brandLogoUploadKey
      if (this.model.brandLogoUploadKey) {
        const uploadKey = this.model.brandLogoUploadKey;
        const isUploading = this.uploadStates[uploadKey] === true;
        const progress = this.uploadProgress[uploadKey];
        const hasActiveProgress = progress !== undefined && progress > 0 && progress < 100;
        if (isUploading || hasActiveProgress) {
          return true;
        }
      }
    }

    // Helper function to check pending media in sections
    // Only consider media as pending if it's explicitly marked as pending or has active uploadKey
    const checkPendingMedia = (sections: any[]): boolean => {
      if (!sections) return false;
      for (const section of sections) {
        if (section.subSections) {
          for (const subsection of section.subSections) {
            if (subsection.media) {
              const hasPendingMedia = subsection.media.some((media: any) => {
                // Check if explicitly marked as pending
                if (media.isPending === true) {
                  return true;
                }

                // Check if has uploadKey and upload is actually in progress
                if (media.uploadKey) {
                  const isUploading = this.uploadStates[media.uploadKey] === true;
                  const progress = this.uploadProgress[media.uploadKey];
                  const hasActiveProgress = progress !== undefined && progress > 0 && progress < 100;

                  // Only consider pending if uploadKey exists AND upload is actually active
                  return isUploading || hasActiveProgress;
                }

                return false;
              });
              if (hasPendingMedia) {
                return true;
              }
            }
          }
        }
      }
      return false;
    };

    // Check for pending videos in model
    if (this.model && this.model.videoSections && checkPendingMedia(this.model.videoSections)) {
      return true;
    }

    // Check for pending photos in model
    if (this.model && this.model.photoSections && checkPendingMedia(this.model.photoSections)) {
      return true;
    }

    // Check for pending files in model
    if (this.model && this.model.fileSections && checkPendingMedia(this.model.fileSections)) {
      return true;
    }

    if (this.model && this.model.mediaSections && checkPendingMedia(this.model.mediaSections)) {
      return true;
    }

    return false;
  }

  getProgressByKey(key: string): number {
    return this.getUploadProgress(key);
  }

  getUploadStateByKey(key: string): boolean {
    return this.getUploadState(key);
  }

  isUploadInProgress(key: string): boolean {
    const isUploading = this.getUploadState(key);
    const progress = this.getUploadProgress(key);

    return isUploading || (progress >= 0 && progress < 100);
  }

  /**
   * Sắp xếp các sections theo index
   */
  private sortSectionsByIndex() {
    // Sắp xếp photo sections
    if (this.model.photoSections && Array.isArray(this.model.photoSections) && this.model.photoSections.length > 0) {
      this.model.photoSections.sort((a, b) => {
        const indexA = a.index !== undefined && a.index !== null ? a.index : 999999;
        const indexB = b.index !== undefined && b.index !== null ? b.index : 999999;
        return indexA - indexB;
      });
    }

    // Sắp xếp video sections
    if (this.model.videoSections && Array.isArray(this.model.videoSections) && this.model.videoSections.length > 0) {
      this.model.videoSections.sort((a, b) => {
        const indexA = a.index !== undefined && a.index !== null ? a.index : 999999;
        const indexB = b.index !== undefined && b.index !== null ? b.index : 999999;
        return indexA - indexB;
      });
    }

    // Sắp xếp file sections
    if (this.model.fileSections && Array.isArray(this.model.fileSections) && this.model.fileSections.length > 0) {
      this.model.fileSections.sort((a, b) => {
        const indexA = a.index !== undefined && a.index !== null ? a.index : 999999;
        const indexB = b.index !== undefined && b.index !== null ? b.index : 999999;
        return indexA - indexB;
      });
    }

    // Sắp xếp media sections
    if (this.model.mediaSections && Array.isArray(this.model.mediaSections) && this.model.mediaSections.length > 0) {
      this.model.mediaSections.sort((a, b) => {
        const indexA = a.index !== undefined && a.index !== null ? a.index : 999999;
        const indexB = b.index !== undefined && b.index !== null ? b.index : 999999;
        return indexA - indexB;
      });
    }
  }

  ngOnDestroy() {
    this.objectUrlsToCleanup.forEach(url => {
      URL.revokeObjectURL(url);
    });
    this.objectUrlsToCleanup.clear();

    // Unsubscribe router events
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    if (typeof window !== "undefined") {
      window.removeEventListener("popstate", this.browserBackHandler);
    }
  }
}
